import SpinnerWhite from 'media/icons/spinner-white.png'

export default function LoadingButton({
    buttonText = 'Button Text',
    isLoading = false,
    spinnerColor = 'white',
    className = 'w-full flex justify-center items-center gap-x-4 bg-orange-500 rounded-full text-white text-sm font-semibold py-2',
    action = () => {
        console.log('Add a button action')
    },
}) {
    return (
        <button className={className} onClick={action} disabled={isLoading}>
            {!isLoading && (
                <>
                    <div>{buttonText}</div>
                </>
            )}

            {isLoading && (
                <>
                    <div>Loading</div>

                    {spinnerColor === 'white' && <img src={SpinnerWhite} alt="Spinner" className="animate-spin h-4 w-4" />}
                </>
            )}
        </button>
    )
}
